<template>
    <div>
        <st-button
            variant="secondary"
            :callback="add"
            v-can:create="'documentSeriesAllocation'"
        >
            <i class="fa fa-plus"></i>
            {{ $t('DOCUMENT_SERIES_ALLOCATION.ADD_BUTTON') }}
        </st-button>
    </div>
</template>

<script>
    export default {
        name: 'DocumentSeriesAllocationListToolbar',
        methods: {
            add() {
                this.$emit('add');
            },
        }
    };
</script>

